module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-passwordmodify"
  }, [_c('navbar', {
    attrs: {
      "title": "重置密码"
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "ui-content",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onCheckSubmit.apply(null, arguments)
      }
    }
  }, [_c('ul', {
    staticClass: "ui-listview ui-listview-inset"
  }, [_c('li', {
    staticClass: "ui-listview-first-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入新密码"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPasswordConfirm),
      expression: "newPasswordConfirm"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请确认新密码"
    },
    domProps: {
      "value": (_vm.newPasswordConfirm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPasswordConfirm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticStyle: {
      "display": "flex",
      "border-top": "1px #ddd solid",
      "border-radius": "0 0 .3125em .3125em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifyCode),
      expression: "verifyCode"
    }],
    attrs: {
      "type": "text",
      "name": "verifyCode",
      "placeholder": "图形验证码"
    },
    domProps: {
      "value": (_vm.verifyCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "height": "36px"
    },
    attrs: {
      "src": _vm.verifyCodeImg
    },
    on: {
      "click": _vm.refreshVerifyCodeClick
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "ui-listview-last-item"
  }, [_c('div', {
    staticClass: "ui-col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vCode),
      expression: "vCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.vCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vCode = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "ui-col-4 ui-align-right"
  }, [_c('mobile-code', {
    attrs: {
      "type": 3,
      "mobile": _vm.telephone,
      "verifyCode": _vm.verifyCode,
      "uuid": _vm.verifyUUID
    },
    on: {
      "on-refresh": _vm.refreshVerifyCodeClick
    }
  })], 1)])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tips),
      expression: "tips"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    staticClass: "ui-controlgroup"
  }, [_c('input', {
    staticClass: "submit",
    attrs: {
      "type": "submit",
      "value": "重置密码"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-79e1be0a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PasswordModify.vue
// module id = 592
// module chunks = 1